export default {
  communityUpates: [],
  dissMissedUpdates: []
}
